import React from "react";
import {
  FormGroupVerticalInput,
  FormGroup,
  Label,
  TextInput,
  SelectInput,
  Textarea,
  PositionFormToggle,
} from "../../components";
import { getInputErrorMessage } from "../../utils";
import { hasErrorInput } from "../../utils";

const PositionForm = ({ positionForm, setPositionForm, errors, features }) => {
  const permissionOptions = [
    { value: 1, label: 1 },
    { value: 2, label: 2 },
    { value: 3, label: 3 },
    { value: 4, label: 4 },
    { value: 5, label: 5 },
    { value: 6, label: 6 },
    { value: 7, label: 7 },
    { value: 8, label: 8 },
    { value: 9, label: 9 },
    { value: 10, label: 10 },
  ];

  const handleChangeFormData = (fieldName, value) => {
    if (typeof value === "boolean") {
      value = value ? 9 : 0;
    }
    setPositionForm((prePositionForm) => ({
      ...prePositionForm,
      [fieldName]: value,
    }));
  };

  return (
    <div className="">
      <FormGroup>
        <Label text="権限No." htmlFor="permission_no" className="w-[200px]" required />
        <FormGroupVerticalInput error={getInputErrorMessage(errors, "permission_no")}>
          <SelectInput
            options={permissionOptions}
            name="permission_no"
            className="w-[80px]"
            hasError={hasErrorInput(errors, "permission_no")}
            value={positionForm.permission_no || "1"}
            onChange={(e) =>
              handleChangeFormData("permission_no", e.target.value)
            }
          />
        </FormGroupVerticalInput>
      </FormGroup>
      <FormGroup>
        <Label text="職位の名前" required={true} htmlFor="name" className="w-[200px]" />
        <FormGroupVerticalInput error={getInputErrorMessage(errors, "name")}>
          <TextInput
            className="w-[400px]"
            name="name"
            id="name"
            hasError={hasErrorInput(errors, "name")}
            onChange={(e) => handleChangeFormData("name", e.target.value)}
            value={positionForm.name || ""}
            maxLength="50"
            autoFocus
          />
        </FormGroupVerticalInput>
      </FormGroup>
      <FormGroup>
        <Label text="説明" htmlFor="description" className="w-[200px]" />
        <FormGroupVerticalInput error={getInputErrorMessage(errors, "description")}>
          <Textarea
            className="w-[400px]"
            name="description"
            rows="2"
            value={positionForm.description || ""}
            maxLength="100"
            onChange={(e) =>
              handleChangeFormData("description", e.target.value)
            }
            hasError={hasErrorInput(errors, "description")}
          />
        </FormGroupVerticalInput>
      </FormGroup>
      {features.template_management && (
        <PositionFormToggle
          labelText={features.template_management}
          fieldName="template_management"
          errors={errors}
          handleChangeFormData={handleChangeFormData}
          checked={positionForm.template_management || "0"}
        />
      )}
      {features.approval_setting_management && (
        <PositionFormToggle
          labelText={features.approval_setting_management}
          fieldName="approval_setting_management"
          errors={errors}
          handleChangeFormData={handleChangeFormData}
          checked={positionForm.approval_setting_management || "0"}
        />
      )}
      {features.machine_management && (
        <PositionFormToggle
          labelText={features.machine_management}
          fieldName="machine_management"
          errors={errors}
          handleChangeFormData={handleChangeFormData}
          checked={positionForm.machine_management || "0"}
        />
      )}
      {features.machine_group_management && (
        <PositionFormToggle
          labelText={features.machine_group_management}
          fieldName="machine_group_management"
          errors={errors}
          handleChangeFormData={handleChangeFormData}
          checked={positionForm.machine_group_management || "0"}
        />
      )}
      {features.department_management && (
        <PositionFormToggle
          labelText={features.department_management}
          fieldName="department_management"
          errors={errors}
          handleChangeFormData={handleChangeFormData}
          checked={positionForm.department_management || "0"}
        />
      )}
      {features.position_management && (
        <PositionFormToggle
          labelText={features.position_management}
          fieldName="position_management"
          errors={errors}
          handleChangeFormData={handleChangeFormData}
          checked={positionForm.position_management || "0"}
        />
      )}
    </div>
  );
};

export default PositionForm;
